import { useState, useEffect, useCallback, useReducer } from 'react';
import { useSelector } from 'react-redux';
import axios from 'axios';
import { selectUserId } from '../selectors/userSelectors';

export interface User {
    gmb?: string | null;
    fb?: string | null;
    opinionSystem?: string | null;
    [key: string]: any;
}

export const useUser = () => {
    const [user, setUser] = useState<User | null>(null);
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const [refreshTrigger, forceRefresh] = useReducer(x => x + 1, 0);
    const userId = useSelector(selectUserId);

    const fetchUser = useCallback(async () => {
        if (userId === undefined) {
            return;
        }

        try {
            setIsLoading(true);
            const response = await axios.get(`/api/users/${userId}`);
            setUser(response.data);
        } catch (error) {
            console.error('Erreur lors du fetch user:', error);
        } finally {
            setIsLoading(false);
        }
    }, [userId]);

    useEffect(() => {
        fetchUser();
    }, [fetchUser, refreshTrigger]);

    const updateUserStatus = useCallback((network: keyof User, status: string | null) => {
        setUser(prevUser => ({
            ...prevUser,
            [network]: status || new Date().toISOString(),
        }));
    }, []);

    const refreshUser = useCallback(() => {
        forceRefresh();
    }, []);

    return {
        user,
        isLoading,
        updateUserStatus,
        refreshUser,
    };
};
